document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.tc-menu-toggle');
  var nav = document.querySelector('.tc-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  var thumbs = document.querySelectorAll('.tc-product-thumb');
  var mainImage = document.getElementById('TcProductImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage && thumb.dataset.full) {
        mainImage.src = thumb.dataset.full;
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});
